import { useGetSessionQuery } from '@store/api/authEndpoints';
import { useAppSelector, useLoading } from '@store/hooks';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useEffect, useId } from 'react';
import AppRouter from './routes/AppRouter';

const App = () => {
  const { refetch } = useGetSessionQuery();
  const authState = useAppSelector((state) => state.auth);
  const { show, hide } = useLoading();

  useEffect(() => { refetch(); }, [refetch]);

  const componentId = useId();

  useEffect(() => {
    (authState.isLoading ? show : hide)(componentId);
  }, [authState.isLoading, hide, componentId, show]);

  return !authState.isLoading ? <AppRouter /> : null;
};

export default App;
